export const GEO_PERMISSION_KEY = 'geolocation-driver';
export const GEO_DENIED = 1;
export const GEO_UNAVAILABLE = 2;
export const HIDE_POPOVER_PAGES = [
  'delivery-loading',
  'on-delivery',
  'pickup-on-delivery',
  'pickup-loading',
];
